import { create } from "zustand";
import axios from "axios";
import { BASE_URL } from "../..";
import {
  ADD_CART_ITEM_API,
  CART_WISHLIST_COUNT_ITEM_API,
  GET_HOME_SEARCH_API,
  GET_MENU_API,
} from "../../app/constants";

const useHomeStore = create((set, get) => ({
  homePageSetting: null,
  collections: [],
  productData: [],
  banners: [],
  fourSalesCard: [],
  error: null,
  searchResults: [],
  cartCount: 0,
  wishlistCount: 0,
  metaTags: {},
  links: [],
  categories: [],
  subCategoriesSlug: [],
  selectedCategoryData: [],
  deals: [],
  pagesData: {},

  // Pagination states
  currentPage: 0,
  totalPages: 1,
  totalResults: 0,

  setCurrentPage: (page) => set({ currentPage: page }),
  setTotalPages: (pages) => set({ totalPages: pages }),
  setTotalResults: (results) => set({ totalResults: results }),

  setMetaTags: (newMetaTags) => set({ metaTags: newMetaTags }),

  fetchData: async (endpoint) => {
    try {
      const response = await axios.get(`${BASE_URL}${endpoint}`);
      const metaTags = response.data.data;

      if (response.status === 200 && response.data.code === 1) {
        set({ metaTags });
      }

      const homePageSetting = response.data.data?.homePageSetting;
      const collections = response.data.data?.collections;
      const getBanners = response.data.data?.banners;

      const filteredCollections = collections?.filter(
        (collection) => collection.type === "MENU_BAR_PAGE"
      );

      set({
        homePageSetting: homePageSetting || null,
        collections: collections || [],
        productData: collections || [],
        banners: getBanners || [],
        fourSalesCard: filteredCollections || [],
        error: null,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },

  fetchMenu: async () => {
    try {
      const response = await axios.get(`${BASE_URL}${GET_MENU_API}`);
      const links = response?.data?.data?.links || [];
      const categories = response?.data?.data?.categories || [];
      set({ links, categories });
      console.log("Fetched menu data:", links, categories);
    } catch (error) {
      console.error("Error fetching menu data:", error);
    }
  },

  fetchCategoryData: async (categorySlug) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/public/collection/${categorySlug}?page=${
          get().currentPage
        }`
      );
      const products = response?.data?.data?.content || [];
      set({ selectedCategoryData: products });
      set({
        pagesData: {
          totalPages: response?.data?.data?.totalPages || 0,
          number: response?.data?.data?.number || 0,
        },
      });
      console.log("Fetched category data:", products);
    } catch (error) {
      console.error("Error fetching category data:", error);
      set({ selectedCategoryData: [] });
    }
  },

  fetchDeals: async () => {
    try {
      const response = await fetch(
        `https://api.lazmy.com/public/collection/today-deal?page=${
          get().currentPage
        }`
      );
      const data = await response.json();
      const products = data?.data?.content || [];

      set({ selectedCategoryData: products });

      if (!response.ok) {
        throw new Error("Failed to fetch deals");
      }

      console.log("API Response:", data);
      set({ deals: products });

      set({
        pagesData: {
          totalPages: data?.data?.totalPages || 0,
          number: data?.data?.number || 0,
        },
      });

      // Set the pagination state values
      set({
        currentPage: data?.data?.number || 0,
        totalPages: data?.data?.totalPages || 1,
        totalResults: data?.data?.totalElements || 0,
      });
    } catch (error) {
      console.log(error);
    }
  },

  // Count wishlist and cart items
  fetchCountProduct: async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");

      const response = await axios.get(
        `${BASE_URL}${CART_WISHLIST_COUNT_ITEM_API}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200 && response.data.code === 1) {
        const { cartCount, wishlistCount } = response.data.data;

        set({
          wishlistCount: wishlistCount,
          cartCount: cartCount,
        });
      } else {
        throw new Error("Invalid response format or code.");
      }
    } catch (error) {
      console.error("Error fetching product counts:", error);
    }
  },

  // Add to cart action
  handleAddToCart: async (inventoryId, quantity) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.post(
        `${BASE_URL}${ADD_CART_ITEM_API}`,
        { productInventoryId: inventoryId, quantity: quantity },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200 && response.data.code === 1) {
        console.log("Product added to cart!");
      } else {
        console.log("Product is not added to cart!");
      }
    } catch (error) {
      console.error("Error adding product to cart:", error);
    }
  },

  // Fetch search API action
  fetchSearchResults: async (query) => {
    try {
      const response = await axios.get(
        `${BASE_URL}${GET_HOME_SEARCH_API}?title=${encodeURIComponent(query)}`
      );

      const searchResults = response.data.data || [];
      set({ searchResults, error: null });
    } catch (error) {
      console.error(error);
    }
  },

  fetchSearchBtn: async (query) => {
    // Check if the query is empty
    if (!query?.trim()) {
      set({ searchResults: [] }); // Clear previous search results if any
      return; // Return early to avoid making the API call
    }

    try {
      const response = await axios.get(
        `${BASE_URL}/public/products/search?title=${encodeURIComponent(query)}`
      );

      if (response.status === 200) {
        console.log("Search Results:", response.data);
        set({
          searchResults: Array.isArray(response.data) ? response.data : [],
        });
      }
    } catch (error) {
      console.error("SearchBtn", error);
    }
  },
}));

export default useHomeStore;
